import Image from "next/image";
import img from "../../public/images/about/contact.jpg";

const ContactFormPhp = () => {
  
  return (
    <>
      <div className="rbt-contact-address">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="thumbnail">
                <Image
                  className="w-100 radius-6"
                  src={img}
                  alt="Contact Images"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="rbt-contact-form contact-form-style-1 max-width-auto">
                <div className="section-title text-start">
                  <span className="subtitle bg-primary-opacity">
                    EDUCATION FOR EVERYONE
                  </span>
                </div>
                <h3 className="title">
                   Contáctanos, estamos listos para escucharte
                </h3>
                <form
                  id="contact-form"
                  className="rainbow-dynamic-form max-width-auto"
                  action="/contact.php" 
                  method="POST"
                >
                  <div className="form-group">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      placeholder="Nombre"
                      required
                    />
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Correo electrónico"
                      required
                    />
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      placeholder="Número de teléfono"
                      required
                    />
                    <span className="focus-border"></span>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Tu mensaje"
                      required
                    />
                    <span className="focus-border"></span>
                  </div>
                  <input type="text" name="hidden_field" style={{display: 'none'}} />
                  <div className="form-submit-group">
                    <button
                      name="submit"
                      type="submit"
                      id="submit"
                      className="rbt-btn btn-md btn-gradient hover-icon-reverse w-100"
                    >
                      <span className="icon-reverse-wrapper">
                        <span className="btn-text">PONTE EN CONTACTO AHORA</span>
                        <span className="btn-icon">
                          <i className="feather-arrow-right"></i>
                        </span>
                        <span className="btn-icon">
                          <i className="feather-arrow-right"></i>
                        </span>
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactFormPhp;
